<template lang="pug">
  section.pedia.u-mt-lg
    AppTitle.u-mb-0(:title="$t('mantra')")

    form.pedia-search.u-mt-lg(@submit.prevent="search")
      input.input(type="text" v-model="query" :placeholder="$t('searchHere')")

      Multiselect(
        :options="categories"
        :searchable="true"
        label="title"
        track-by="id"
        placeholder="Categories"
        v-model="selectedCategory"
      )
      Multiselect(
        :options="letters"
        :searchable="true"
        placeholder="A/Z"
        v-model="startingLetter"
      )
      button.button.is-inverse {{$t('search')}}

    Query.grid.is-widescreen-8.is-desktop-10.is-center.u-mt-lg(
      :query="require('~/graphql/Glossary.gql').Definitions"
      :initialValue="definitions"
      :variables="{ startingLetter, selectedCategory, query }"
      v-slot="{ items, isFetching }"
    )
       .column
          template(v-if="items.length")
            .pediaCard.u-mb-md(v-for="item in items")
              h3 {{ item.title }}
              AppContent.u-mb-xs
                p {{ item.body }}
              .u-mt-ts
                .pediaCard-links
                  div(v-for="link in item.links" :key="link.id")
                    span.pediaCard-link {{ link.title }}
          template(v-else-if="!isFetching")
            h4.u-textCenter {{$t('noResults')}}

</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { load } from '~/directives';
import TextInput from '~/components/inputs/TextInput';
import { GetCategories, Definitions } from '~/graphql/Glossary.gql';
import { generateSeoMeta } from '~/utils/seo';
import Query from '~/components/Query';
import Content from '~/components/Content';

export default {
  scrollToTop: true,
  meta: {
    theme: 'pedia',
    logoText: 'atlas'
  },
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc', image: 'pageImg' }, { i18n: true }),
  directives: {
    load
  },
  components: {
    TextInput,
    Multiselect,
    Query,
    Content
  },
  async asyncData({ app }) {
    const [items, categories] = await Promise.all([
      app.$api.query({
        query: Definitions,
        variables: { first: 10 }
      }),
      app.$api.query({
        query: GetCategories
      })
    ]);

    return {
      definitions: items.data.definitions,
      categories: categories.data.glossaryCategories
    };
  },
  data: () => ({
    letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
    query: '',
    startingLetter: null,
    selectedCategory: null
  })
};
</script>

<style lang="stylus">
.pediaCard-links
  display: flex
  flex-wrap: wrap
  margin-left: -10px
  margin-right: -10px

  >div
    margin: 0 10px 10px

.pediaCard-link
  font-size: unitRes(12, 18)

.pedia-search
  display: flex
  align-items: flex-start

  +mq($until: 'tablet')
    display: block

    .Multiselect
      margin-bottom: 10px

  .button
    height: $inputHeight

  .input
    flex: 0 0 60%
    width: 60%

    +mq($until: 'widescreen')
      flex: 0 0 40%
      width: 40%

    +mq($until: 'tablet')
      flex: 0 0 100%
      width: 100%
      margin-bottom: 10px

  .Multiselect .multiselect__option--highlight:after
    display: none
</style>

<i18n>
{
  "en": {
    "pageTitle":"Baianat atlas",
    "pageDesc":"Search your field terminology, theories and more. From design to code, business and technology, our Wiki covers a variety of fields.",
    "pageImg":"https://cdn.baianat.com/static/share/atlas.png",
    "mantra":"Search anything |in your field.",
    "search":"Search",
    "searchHere":"Search here",
    "noResults":"Sorry no results found."
  },
  "ar": {
    "pageTitle":"أطلس",
    "pageDesc":"ابحث في مجال عملك عن المصطلحات والكلمات الرئيسية والنظريات في مجالات التصميم والبيزنس والتكنولوجيا والبرمجة نغطي مختلف المجالات. ",
    "pageImg":"https://cdn.baianat.com/static/share/atlas.png",
    "mantra":"ابحث عن أي شيء |في مجال عملك.",
    "search":"بحث",
    "searchHere":"ابحث هنا",
    "noResults":"عذرا لا يوجد نتائج."
  }
}
</i18n>
